import { message } from "antd";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getTnCPolicy } from "../../../controller/services/common";
import i18n from "../../../localization/i18n";
import { setLoading } from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";

const TermsAndConditionsDetails = (props) => {
  const [termsData, setTermsData] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    fetchTermsNConditions();
  }, []);
  const fetchTermsNConditions = () => {
    dispatch(setLoading(true));
    getTnCPolicy("terms")
      .then((resp) => {
        setTermsData(resp.data);
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  return (
    <>
      <div
        className={`row condition-row-first position-relative ${
          props.uiChangeConditions == "ui-change"
            ? "settings-theme-condition"
            : ""
        }`}
      >
        <a
          href={routePaths.signUp}
          className={`back-arrow-btn back-arrow-btn-condition ${
            props.backArrowRemove == "no-need-arrow" ? "d-none" : ""
          }`}
        >
          <img
            alt=""
            className="img-fluid"
            src="/assets/images/icons/back-arrow-with-bg.svg"
          />
        </a>
        <div className="col-12">
          <div className="row">
            <div
              className={`col-12 col-sm-12 col-md-12 ${
                props.uiChangeConditions == "ui-change"
                  ? "col-lg-12 col-xl-12 mx-0"
                  : "col-lg-10 col-xl-10 mx-auto"
              }`}
            >
              <div className="row condition-header-row">
                <div className="col-12">
                  <div className="condition-logo-card">
                    <img
                      src="/assets/images/icons/condition-icon-primary.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <h1>{t("settings.tnc")}</h1>
                  <p>
                    {t("settings.lastUpdated")}{" "}
                    {termsData?.updatedAt
                      ? format(new Date(termsData?.updatedAt), "MMM dd, yyyy")
                      : ""}
                  </p>
                </div>
              </div>
              <div className="row condtitons-descripations-row">
                <div
                  className="col-12"
                  dangerouslySetInnerHTML={{
                    __html: termsData?.description?.[i18n.language]
                      ? termsData?.description?.[i18n.language]
                      : "",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionsDetails;
